import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function Proof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-lighter px-4 py-16 md:py-24" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-127">
          <h2 className="font-bebas text-4xl md:text-6xl text-white leading-tight" data-id="element-128">
            ¿QUÉ CAMBIA EN 7 DÍAS?
          </h2>

          <div className="bg-dark border-l-4 border-teal rounded-lg p-8 md:p-12" data-id="element-129">
            <p className="font-inter text-lg md:text-xl text-text/90 leading-relaxed italic" data-id="element-130">
              No te convertirás en un superhumano a los 7 días. Pero notarás que
              el libro que antes no podías leer, ahora te atrapa. La comida
              sabrá diferente. Tu piel se verá más clara y tus ojos tendrán un
              brillo de alerta que habías olvidado. Es el retorno de tu energía
              vital.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}